export default __webpack_public_path__ + "static/media/bounty.51feec73.svg";